<template>
    <div class="roboto-300">
        <div v-if="userName == ''" class="dropdown">
            <button class="btn btn-secondary" type="button" @click="show">
                <i class="fas fa-sign-in-alt"></i>
                <span class="d-none d-lg-inline me-2 fw-300">Login</span>
            </button>
        </div>
        <div v-else class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="user-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i v-if="userMember" class="fas fa-user-check text-success" title="Member district"></i>
                <i v-else class="fas fa-user"></i>
                <span class="d-none d-lg-inline me-2 fw-300">{{ userName }}</span>
            </button>
            <ul class="dropdown-menu roboto" aria-labelledby="user-dropdown">
                <li><a href="javascript:void(0)" class="dropdown-item" @click="$router.push('/user/transcripts')"><i class="fas fa-user-graduate me-2 text-center" style="width: 1em;"></i>Transcripts</a></li>
                <li><a href="javascript:void(0)" class="dropdown-item" @click="$router.push('/user/update')"><i class="fas fa-user-edit me-2 text-center" style="width: 1em;"></i>Update&nbsp;Account</a></li>
                <!-- <li><a href="/user/password" class="dropdown-item"><i class="fas fa-lock me-2 text-center" style="width: 1em;"></i>Change&nbsp;Password</a></li> -->
                <li><a href="javascript:void(0)" class="dropdown-item" @click="logout"><i class="fas fa-sign-out-alt me-2 text-center" style="width: 1em;"></i>Logout</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userName: {
            type: String,
            default: '',
        },

        userMember: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        show() {
            this.eventHub.$emit('loginPressed');
        },

        logout() {
            this.eventHub.$emit('logoutPressed');
        }
    },

    data() {
        return {
            modal: null,
        }
    },
}
</script>